module.exports = __webpack_public_path__ + "img/customer-landing-page-default@1x.49cd14b5.png";